import {
  exchangeElectronMessage as internalExchangeElectronMessage,
  pollExchangeElectronMessage as internalPollExchangeElectronMessage,
  sendElectronMessage as internalSendElectronMessage,
} from './shared.app-utils';
import {
  CancelExchange,
  CommonMessage,
  CommonMessageForResponse,
  CommonMessageResponse,
  ExchangeOptions,
  PollOptions,
} from './shared.types';

export {CommonMessageType, AppType} from './shared.types';
export type {
  CancelExchange,
  CommonMessageForResponse,
  CommonMessageResponse,
  ExchangeOptions,
  PollOptions,
} from './shared.types';
export {isElectron} from './shared.app-utils';

/**
 * Sends a message to the electron backend without repeating the "window.postMessage" stuff every time.
 */
export const sendElectronMessage = (message: CommonMessage): void =>
  internalSendElectronMessage(message);

/**
 * Sends a message with the specified messageType to the lexian-browser and handles the response's
 * payload with the specified responsePayloadHandler.
 *
 * If the type is not included in the response the event is _not_ handled.
 * Returns a handle which cancels the exchange when it is no longer of interest.
 */
export function exchangeElectronMessage<T extends CommonMessageForResponse>(
  message: T,
  responsePayloadHandler: (response: CommonMessageResponse[T['type']]) => void,
  options?: ExchangeOptions
): CancelExchange {
  return internalExchangeElectronMessage(
    message,
    responsePayloadHandler,
    options
  );
}

/**
 * Polls the lexian-browser with the given message: a round starts immediately
 * and then every intervalInMs. The round still pending when the next one
 * starts is cancelled, so rounds can never pile up. Returns a handle which
 * stops polling and cancels the pending round.
 */
export function pollExchangeElectronMessage<T extends CommonMessageForResponse>(
  message: T,
  responsePayloadHandler: (response: CommonMessageResponse[T['type']]) => void,
  options: PollOptions
): CancelExchange {
  return internalPollExchangeElectronMessage(
    message,
    responsePayloadHandler,
    options
  );
}
